import MDivider from '@mui/joy/Divider';
import type { DividerProps as MDividerProps } from '@mui/joy/Divider';

export const Divider: typeof MDivider = MDivider;
export type DividerProps = MDividerProps;
// export { DividerClasses };

export * from '@mui/joy/Divider';
